import { BreadcrumbHeading, Typography } from '@weareopenr/component-library';

interface PlaceholderPageProps {
  title: string;
  description: string;
}

export const PlaceholderPage = ({ title, description }: PlaceholderPageProps) => (
  <>
    <BreadcrumbHeading breadcrumbs={[{ label: title }]} />
    <Typography size="medium">{description}</Typography>
  </>
);
